<div class="dialog-container">
  <div class="dialog-header">
    <h2>जाहिरात व्यवसाय अहवाल - विस्तृत</h2>
  </div>

  <div class="dialog-content">
    <!-- Loading Indicator -->
    <span class="loader" *ngIf="isLoading"></span>

    <!-- Report Table -->
    <div *ngIf="!isLoading && businessReportData.length > 0" class="report-wrapper print-section"
      id="business-report-table">
      <table class="ledger-table">
        <thead>
          <!-- Title Row -->
          <tr>
            <th colspan="5" class="title-bg">
              जाहिरात विभाग नियोजन - {{ financialYearLabel }}
            </th>

            <th [attr.colspan]="getTotalColspan()" class="main-header-bg">
              वर्ष {{ getFinancialYearDisplay() }} - प्रतिनिधी / विभागातून आलेल्या जाहिरातींचा तपशिल
            </th>

            <th rowspan="4" class="total-header">एकूण</th>
            <th rowspan="4" class="total-header">जाहिरात करार वापरणे बाकी</th>
            <th rowspan="4" class="total-header" style="background-color: #2e7d32 !important; color: #fff !important;">
              एकूण<br>वयवसाय
            </th>
            <th rowspan="4" class="total-header">रक्कम प्रविष्ट करा</th>
            <th rowspan="4" class="total-header">नरेशन</th>
            <th rowspan="4" class="total-header" style="background-color: #1565c0 !important; color: #fff !important;">
              एकूण<br>वयवसाय
            </th>
          </tr>

          <!-- Main Month Headers Row -->
          <tr>
            <th rowspan="3" class="vertical-text">कार्यालय प्रतिनिधी</th>
            <th rowspan="3">जिल्हा</th>
            <th rowspan="3">तालुके</th>
            <th rowspan="3">अ.क्र.</th>
            <th rowspan="3">प्रतिनिधी</th>

            <!-- Dynamic Month Headers -->
            <ng-container *ngFor="let monthData of headerStructure">
              <th [attr.colspan]="monthData.colspan" class="month-header">
                {{ monthMarathi[monthData.month] }} {{ monthData.year_suffix }}
              </th>
            </ng-container>
          </tr>

          <!-- Issue Names Row -->
          <tr>
            <ng-container *ngFor="let monthData of headerStructure">
              <ng-container *ngFor="let issue of monthData.issues">
                <th *ngIf="!issue.has_sub_issues" rowspan="2" class="vertical-text">
                  {{ issue.name }}
                </th>
                <th *ngIf="issue.has_sub_issues" [attr.colspan]="issue.sub_issues?.length" class="issue-header">
                  {{ issue.name }}
                </th>
              </ng-container>
            </ng-container>
          </tr>

          <!-- Sub-Issue Names Row -->
          <tr>
            <ng-container *ngFor="let monthData of headerStructure">
              <ng-container *ngFor="let issue of monthData.issues">
                <ng-container *ngIf="issue.has_sub_issues">
                  <th *ngFor="let subIssue of issue.sub_issues" class="vertical-text"
                    style="text-align: center; font-weight: bold; font-size: 12px; border: 1.5px solid #000000 !important;">
                    {{ subIssue === 'prasangik' ? 'प्रासंगिक' : 'करार' }}
                  </th>
                </ng-container>
              </ng-container>
            </ng-container>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let row of businessReportData; let i = index">

            <!-- ── Data Row ── -->
            <tr>
              <td *ngIf="row.is_first_off_rep_row" [attr.rowspan]="row.off_rep_rowspan" class="off-rep-cell"
                style="text-align: left; font-size: 14px; font-weight: bold; vertical-align: top;">
                {{ row.off_rep_name }}
              </td>

              <td *ngIf="row.is_first_district_row" [attr.rowspan]="row.district_rowspan" class="district-cell"
                style="vertical-align: top;">
                {{ row.district }}
              </td>

              <td *ngIf="row.is_first_taluka_row" [attr.rowspan]="row.taluka_rowspan" class="taluka-cell"
                style="vertical-align: top;">
                {{ row.taluka || '-' }}
              </td>

              <td>{{ row.serial }}</td>
              <td>{{ row.rep_name }}</td>

              <ng-container *ngFor="let monthData of headerStructure">
                <ng-container *ngFor="let issue of monthData.issues">
                  <td *ngIf="!issue.has_sub_issues" class="amount-cell">
                    {{ formatCurrency(getIssueValue(row, monthData.month, monthData.year_suffix, issue.name)) }}
                  </td>
                  <ng-container *ngIf="issue.has_sub_issues">
                    <td *ngFor="let subIssue of issue.sub_issues" class="amount-cell">
                      {{ formatCurrency(getIssueValue(row, monthData.month, monthData.year_suffix, issue.name,
                      subIssue)) }}
                    </td>
                  </ng-container>
                </ng-container>
              </ng-container>

              <td class="total-cell">{{ formatCurrency(calculateRowTotal(row)) }}</td>
              <td class="total-cell">{{ formatCurrency(row.jaahirat_karar_baki) }}</td>
              <td class="total-cell" style="background-color: #e8f5e9 !important; font-weight: bold;">
                {{ formatCurrency(calculateCombinedTotal(row)) }}
              </td>
              <td class="amount-cell">
                <input type="number" [(ngModel)]="row.user_amount" class="table-input" />
              </td>
              <td class="amount-cell">
                <input type="text" [(ngModel)]="row.narration" class="table-input" />
              </td>
              <td class="total-cell" style="background-color: #bbdefb !important; font-weight: bold;">
                {{ formatCurrency(calculateFinalTotal(row)) }}
              </td>
            </tr>

            <!-- ── District Total Row ── -->
            <tr *ngIf="row.is_last_district_row" style="background-color: #e3f2fd; font-weight: bold;">
              <td colspan="4" style="text-align: right; padding-right: 10px;">
                {{ row.district }} - जिल्हा एकूण
              </td>

              <ng-container *ngFor="let monthData of headerStructure">
                <ng-container *ngFor="let issue of monthData.issues">
                  <td *ngIf="!issue.has_sub_issues" class="total-cell">
                    {{ formatCurrency(calculateDistrictIssueTotal(row.off_rep_name, row.district, monthData.month,
                    monthData.year_suffix, issue.name)) }}
                  </td>
                  <td *ngFor="let sub of (issue.sub_issues || [])" class="total-cell">
                    {{ formatCurrency(calculateDistrictIssueTotal(row.off_rep_name, row.district, monthData.month,
                    monthData.year_suffix, issue.name, sub)) }}
                  </td>
                </ng-container>
              </ng-container>

              <td class="total-cell">{{ formatCurrency(calculateDistrictRowTotal(row.off_rep_name, row.district)) }}
              </td>
              <td class="total-cell">{{ formatCurrency(calculateDistrictColumnTotal(row.off_rep_name, row.district,
                'jaahirat_karar_baki')) }}</td>
              <td class="total-cell" style="background-color: #e8f5e9 !important; font-weight: bold;">
                {{ formatCurrency(calculateDistrictCombinedTotal(row.off_rep_name, row.district)) }}
              </td>
              <td colspan="2"></td>
              <td class="total-cell" style="background-color: #bbdefb !important; font-weight: bold;">
                {{ formatCurrency(calculateDistrictFinalTotal(row.off_rep_name, row.district)) }}
              </td>
            </tr>

            <!-- ── Off-Rep Total Row ── -->
            <tr *ngIf="row.is_last_off_rep_row" style="background-color: #fff3cd; font-weight: bold; font-size: 14px;">
              <td colspan="5" style="text-align: right; padding-right: 10px; background-color: #fff3cd; font-weight: bold;font-size:
                14px;">
                {{ row.off_rep_name }} - एकूण
              </td>

              <ng-container *ngFor="let monthData of headerStructure">
                <ng-container *ngFor="let issue of monthData.issues">
                  <td *ngIf="!issue.has_sub_issues" class="total-cell"
                    style="background-color: #fff3cd !important; font-weight: bold;">
                    {{ formatCurrency(calculateOffRepIssueTotal(row.off_rep_name, monthData.month,
                    monthData.year_suffix, issue.name)) }}
                  </td>
                  <td *ngFor="let sub of (issue.sub_issues || [])" class="total-cell"
                    style="background-color: #fff3cd !important; font-weight: bold;">
                    {{ formatCurrency(calculateOffRepIssueTotal(row.off_rep_name, monthData.month,
                    monthData.year_suffix, issue.name, sub)) }}
                  </td>
                </ng-container>
              </ng-container>

              <td class="total-cell" style="background-color: #fff3cd !important; font-weight: bold;">
                {{ formatCurrency(calculateOffRepTotal(row.off_rep_name)) }}
              </td>
              <td class="total-cell" style="background-color: #fff3cd !important; font-weight: bold;">
                {{ formatCurrency(calculateOffRepColumnTotal(row.off_rep_name, 'jaahirat_karar_baki')) }}
              </td>
              <td class="total-cell" style="background-color: #ffe082 !important; font-weight: bold;">
                {{ formatCurrency(calculateOffRepCombinedTotal(row.off_rep_name)) }}
              </td>
              <td colspan="2" style="background-color: #fff3cd !important;"></td>
              <td class="total-cell" style="background-color: #90caf9 !important; font-weight: bold;">
                {{ formatCurrency(calculateOffRepFinalTotal(row.off_rep_name)) }}
              </td>
            </tr>

          </ng-container>
        </tbody>

        <!-- Footer with Grand Totals -->
        <tfoot>
          <tr class="total-row" style="font-weight: bold;">
            <td colspan="5" class="footer-total-label">एकूण</td>

            <ng-container *ngFor="let monthData of headerStructure">
              <ng-container *ngFor="let issue of monthData.issues">
                <td *ngIf="!issue.has_sub_issues" class="total-cell" style="font-weight: bold;">
                  {{ formatCurrency(calculateIssueTotal(monthData.month, monthData.year_suffix, issue.name)) }}
                </td>
                <ng-container *ngIf="issue.has_sub_issues">
                  <td *ngFor="let subIssue of issue.sub_issues" class="total-cell" style="font-weight: bold;">
                    {{ formatCurrency(calculateIssueTotal(monthData.month, monthData.year_suffix, issue.name, subIssue))
                    }}
                  </td>
                </ng-container>
              </ng-container>
            </ng-container>

            <td class="grand-total" style="font-weight: bold;">{{ formatCurrency(calculateGrandTotal()) }}</td>
            <td class="grand-total" style="font-weight: bold;">{{
              formatCurrency(calculateColumnTotal('jaahirat_karar_baki')) }}</td>
            <td class="grand-total" style="background-color: #c8e6c9 !important; font-weight: bold;">
              {{ formatCurrency(calculateCombinedGrandTotal()) }}
            </td>
            <td class="grand-total" style="font-weight: bold;">{{ formatCurrency(calculateColumnTotal('user_amount')) }}
            </td>
            <td class="total-cell" style="font-weight: bold;"></td>
            <!-- <td class="total-cell" style="font-weight: bold;"></td> -->
            <td class="grand-total"
              style="background-color: #1565c0 !important; color: #fff !important; font-weight: bold;">
              {{ formatCurrency(calculateGrandFinalTotal()) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- Dialog Actions -->
  <div class="dialog-actions">
    <button mat-raised-button color="primary" [useExistingCss]="true" (click)="printPageA3Portrait()">
      Print
    </button>
    <button mat-raised-button color="primary" (click)="exportToExcel()"
      [disabled]="isLoading || businessReportData.length === 0">
      <mat-icon>download</mat-icon>
      Excel निर्यात करा
    </button>
    <button mat-raised-button (click)="closeDialog()">
      बंद करा
    </button>
  </div>
</div>